export const fontWeights = {
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
}